<div class="radio">  
  <label>  
      <input type="radio" name="login" value="Docs" (click)="setradio('Docs')" [checked]='true' ngModel>  
      Doctor Login
  </label>  
</div>  
<div class="radio">  
  <label>  
      <input type="radio" name="login" value="Normal" (click)="setradio('Normal')" ngModel>  
      Normal User Login
  </label>  
</div>  

<div>  
  <button (click)='goToLoginPage()'> OK </button> 
</div>  
 